import { useRef, useState } from "react";
import { Form } from "./Form";
import { IPermissionProps } from "../../models/Login";
import { Toast } from "primereact/toast";
import { EmptyExtCalling, IExtensionCalling, Table } from "./Table";

export interface IModal {
    singleData: IExtensionCalling,
    open: boolean
}

export const CallingExtension = (permissions: IPermissionProps) => {
    const [modal, setModal] = useState({ singleData: {}, open: false } as IModal);
    const [reload, setReload] = useState(false);
    const toast = useRef<any>(null);

    const hideDialog = () => {
        setModal({ singleData: EmptyExtCalling, open: false });
    };

    return (
        <>
            <Form singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload}></Form>
            <Table permissions={permissions} setModal={setModal} toast={toast} reload={reload} setReload={setReload}></Table>
            <Toast ref={toast} />
        </>
    );
}